import { Swiper, Pagination, Navigation } from 'swiper'
import 'swiper/swiper-bundle.min.css'

Swiper.use([Pagination, Navigation])

const app = {
  init: () => {
    new Swiper('.BettingSlider', {
      spaceBetween: 10,
      slidesPerView: 'auto',
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      breakpoints: {
        992: {
          slidesPerView: 4,
          slidesPerGroup: 4,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        }
      }
    })
  }
}

app.init()